<template>
    <div >
        <div class="effect-blur mo" v-observe-visibility="visibilityChanged"
             v-bind:class="{'visible':isVisible}" >
            <figure class="image is-128x128 jacket effect-blur-thumb" v-on:click="openModal">
                <img :src="src" @load="loaded">
            </figure>

            <div class="effect-blur-over is-hidden-mobile" v-on:click="openModal">
                <vue-loading type="spin" color="#333" :size="{ width: '50px', height: '50px' }" v-show=loadme></vue-loading>
            <p class="has-text-weight-light"> {{title}}</p>
            </div>
        </div>

<!--            TODO なんかアニメーションしないのが嫌-->
            <div class="modal modal-fx-fadeInScale" v-bind:class="{'is-active':modal}">
                <div class="modal-background" v-on:click="closeModal"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title has-text-left subtitle">{{title}}</p>
                        <button class="delete" aria-label="close" data-target="my-modal" @click="closeModal"></button>
                    </header>

                    <section class="modal-card-body">
                        <div class="content columns is-multiline">
                            <figure class="image  column is-6-desktop">
                                <img :src="src">
                            </figure>
                            <div class="column is-5-desktop">
                                <p class="subtitle">{{subtitle}}</p>
                                <p>{{text}}</p>
                            </div>
                        </div>
                    </section>

                    <footer class="modal-card-foot">
                        <a :href="link"　target="_blank">{{linkname}}</a>
                    </footer>

                </div>
            </div>
    </div>
</template>

<script>
    import { VueLoading } from 'vue-loading-template'

    export default {
        name: "modal",
        data() {
            return {
                isVisible:false,
                modal: false,
                loadme:true
            }
        },
        components: {
            VueLoading
        },
        props: [
            'title',
            'src',
            'text',
            'subtitle',
            'link',
            'linkname'
        ],
        methods: {
            openModal() {
                this.modal = true
            },
            closeModal() {
                this.modal = false
            },
            visibilityChanged (isVisible, entry) {
                this.isVisible = isVisible
                console.log(entry)
            },
            loaded(){
                this.loadme =false;
            }
        }

    }
</script>

<style  scoped>
    p{
        overflow-wrap: break-word;
        word-wrap: break-word;
        font-size: 14px;
    }
    .modal-card{
        width: 90%;
    }
    .modal-card-head{
        color: black;
        border-bottom: 0px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }
    .modal-card-foot{
        border-top: 0px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
    .jacket{
        transition:0.5s all ease 0s;
    }
    .jacket:hover{
        transform: scale(1.03);
    }
    .modal-card{
        transition:0.5s all ease 0s;
    }
    .effect-blur-over{
        position: absolute;
        display: flex;
        align-items: center;
        opacity: 0;
        left: 0px;
        top: 0px;
        height: 100%;
        transition: all 0.3s ease;
        transform: scale(1.2);
        color: black;

    }
    .effect-blur-thumb{
        transition: all 0.3s ease;
    }

    .effect-blur:hover .effect-blur-thumb{
        filter:blur(2px) brightness(1.5);
    }

    .effect-blur:hover .effect-blur-over{
        opacity: 1;
        transform: scale(1.0);
    }
    .effect-blur{
        position: relative;
    }

    .mo{
        opacity:0.0;
        transform: translateX(10px);
        transition: 0.5s ease-in-out;
    }
    .visible{
        opacity:1.0;
        transform: translateX(0);
    }
    .subtitle{
        margin-bottom: 0;
        padding-bottom: 0;
        font-size: 24px;
    }

    img{
        filter: drop-shadow(5px 5px 5px rgba(0,0,0,0.6));
    }
    .modal-card-title{
        font-size:24px;
    }
</style>